import {l} from 'i18n-js';
import I18n from 'i18n-js';
import type {Readyness} from './product';

export function formatPrice(price: number, options?: I18n.ToCurrencyOptions) {
    let unit: string = options?.unit ?? YooconShop.shop.currencies[0];
    unit = YooconShop.shop.currency_symbols[unit] ?? unit;
    return l('currency', price, {format: '%u%n', ...options, unit})
        .replaceAll(" ", "\u00a0");
}

const READYNESS: {[locale: string]: {[key: string]: string}} = {
    en: {
        d: "business day",
        dd: "business days",
        w: "week",
        ww: "weeks",
        m: "month",
        mm: "months",
        y: "year",
        yy: "years",
    },
    de: {
        d: "Werktag",
        dd: "Werktage",
        w: "Woche",
        ww: "Wochen",
        m: "Monat",
        mm: "Monate",
        y: "Jahr",
        yy: "Jahre,"
    },
};

export function formatReadyness(readyIn: Readyness, country: string = '*', casus: 'nom' | 'dat' = 'nom') {
    if(typeof readyIn != 'string')
        readyIn = readyIn[country] || readyIn['*'];
    const time = readyIn.substr(0, readyIn.length-1).replaceAll('-', "\u{2011}"),
          n = parseInt(time);
    let u = readyIn[readyIn.length-1];
    const plural = n != 1;
    if(plural)
        u += u;
    const t = READYNESS[I18n.locale] || READYNESS.en;
    let unit = t[u];
    if(plural && I18n.locale == 'de' && casus == 'dat') {
        if(!unit.endsWith('n'))
            unit += 'n';
    }
    return `${time}\u{a0}${unit}`;
}

export function formatSentence(items: Array<string | number>, sep0: string, sep1: string) {
    let result = '';
    const last = items.length - 2;
    items.forEach((item, index) => {
        result += String(item);
        if(index < last)
            result += sep0;
        else if(index === last)
            result += sep1;
    });
    return result;
}
